<template>
  <v-container fluid>
    <v-row class="mb-7">
      <RangeFilter 
        :end="dateEnd" 
        :start="dateStart" 
        @getDates="getDates" 
        :excludePeriod="excludePeriod"
        :defaultPeriod="defaultPeriod"
        :setDates="true"
        :disabled="loaded"
      />
    </v-row>
    <vue-chart type="line" :data="chartData1" :options="options2"></vue-chart>
    <v-data-table
        :headers="headers"
        :items="data.inquires_total"
        item-key="id"
        class="elevation-1"
        :loading="loaded"
        loading-text="Loading... Please wait"
        @click:row="rowClick"
    >
      <template v-slot:no-data>
        <span>No data</span>
      </template>
    </v-data-table>

  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'

export default {
  components: {
    RangeFilter
  },
  data() {
    return {
      hideAnything: false,
      selected: [],
      headers: [
        {text: 'Subject', value: 'subject'},
        {text: 'Count', value: 'count'},
      ],
      data: [],
      historyChanged: [],
      userName: null,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
                  Date.UTC(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      loaded: false,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Count'
              },
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Dates'
              },
              type: 'time',
              time: {
                unit: 'day'
              }
            }
          ]
        },
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: 'x',
            },

            zoom: {
              enabled: true,
              drag: false,
              mode: 'x',
            }
          }
        }
      },
      options2: {
        responsive: true,
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: 'x',
            },

            zoom: {
              enabled: true,
              drag: false,
              mode: 'x',
            }
          }
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Count',
                scaleShowLabels: true
              },
              ticks: {
                autoSkip: false,
                display: true,
                
              }
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Dates'
              },
              ticks: {
                autoSkip: false,
                display: true
              },
              type: 'time',
              distribution: 'series',
              time: {
                unit: 'day',
              }
            }
          ],
        },
      },
      chartData1: {
        labels: [],
        datasets: [
            {
              label: '',
              data: [],
              backgroundColor: [
              'rgba(242, 243, 252, 0.2)',
              ],
              borderColor: [
                'rgba(99, 114, 195, 1)', // blue
                
              ],
              borderWidth: 2,
              hoverBorderWidth: 2,
              hoverBackgroundColor: 'rgba(54,162,235, 1)',
              pointBackgroundColor: 'rgba(99, 114, 195, 1)',
              pointBorderColor: 'rgba(99, 114, 195, 1)',
              pointBorderWidth: 1,
              pointHitRadius: 1,
              pointHoverBackgroundColor: 'rgba(255, 255, 255, 1)',
            },

            {
              label: '',
              data: [],
              backgroundColor: [
                'rgba(237, 250, 245, 0.2)',
              ],
              borderColor: [
                'rgba(130, 221, 184, 1)', // green
              ],
              borderWidth: 2,
              hoverBorderWidth: 2,
              hoverBackgroundColor: 'rgba(75,192,192, 1)',
              pointBackgroundColor: 'rgba(130, 221, 184, 1)',
              pointBorderColor: 'rgba(130, 221, 184, 1)',
              pointBorderWidth: 1,
              pointHitRadius: 1,
              pointHoverBackgroundColor: 'rgba(255, 255, 255, 1)',
            },
            
            {
              label: '',
              data: [],
              backgroundColor: [
                'rgba(249, 235, 239, 0.2)'
              ],
              borderColor: [
                'rgba(216, 118, 145, 1)', // red
              ],
              borderWidth: 2,
              hoverBorderWidth: 2,
              hoverBackgroundColor: 'rgba(249, 235, 239, 1)',
              pointBackgroundColor: 'rgba(255, 99, 132, 1)',
              pointBorderColor: 'rgba(255, 99, 132, 1)',
              pointBorderWidth: 1,
              pointHitRadius: 1,
              pointHoverBackgroundColor: 'rgba(255, 255, 255, 1)',
            },
        ]
      }
    }
  },
  watch: {

  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }
    
    axios
        .get('/username')
        .then(response => (this.userName = response.data))
    this.applyFilters()
  },
  methods: {
    getDates(dates){
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
       this.applyFilters()
    },
    applyFilters() {
      this.loaded = true
      axios
          .get('/dashboard/inquires/' + this.dateStart + '/' + this.dateEnd)
          .then(response => {
            this.data = response.data

            let counter = 0
            this.data.inquires_total.map(e => {
              e.id = counter++
              return e
            })

          for (let i = 0; i < this.data.inquires_graph.datasets.length; i++) {
            this.chartData1.datasets[i].data =  this.data.inquires_graph.datasets[i].data
            this.chartData1.datasets[i].label =  this.data.inquires_graph.datasets[i].label       
          }
          this.chartData1.labels =  this.data.inquires_graph.labels

          this.loaded = false
        })
    },
    rowClick: function (item, row) {     
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    }
  }
}
</script>

<style scoped>

</style>